module.exports = __webpack_public_path__ + "theme/assets/img/44821cc2104efb4b019aa143adeeea06.png";